import { combineReducers } from "redux";
import authReducer from "./authReducer";
import employeeReducer from "./employeeReducer";
import attendanceReducer from "./attendanceReducer";
import leaveReducer from "./leaveReducer";
import dashboardReducer from "./dashboardReducer";
import taskReducer from "./taskReducer";
import tasksTitleReducer from "./tasksTitleReducer";
import holidayReducer from "./holidayReducer";
import roleReducer from "./roleReducer";
import geofenceReducer from "./geofenceReducer";
import taskTrackingReducer from "./taskTrackingReducer";
import locationReducer from "./locationReducer";
import VisitLocationReducer from "./VisitLocationReducer"; // make sure the path is correct
import userReducer from "./userReducer";
import userBulkUploadReducer from "./userBulkUploadReducer";
import leaveTypeReducer from "./leaveTypeReducer";
import designationReducer from "./designationReducer";
import districtsReducer from "./districtsReducer";
import municipalitiesReducer from "./municipalitiesReducer";
import adminReducer from "./AdminReducer"; // ✅ Import Admin Reducer
import parkGeofenceReducer from "./parkGeofenceReducer";
import taskAdminReducer from "./CreateTasksAdminReducer";
import WebAdminReducer from "./WebAdminReducer";
import blogReducer from "./blogReducer";
import jobReducer from "./jobReducer";
import officeReducer from "./officeReducer";
import shiftReducer from "./shiftReducer";
import attendanceReportReducer from "./attendanceReportReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  employee: employeeReducer,
  attendance: attendanceReducer,
  leave: leaveReducer,
  dashboard: dashboardReducer,
  task: taskReducer,
  tasksTitle: tasksTitleReducer,
  holiday: holidayReducer,
  role: roleReducer,
  geofence: geofenceReducer,
  taskTracking: taskTrackingReducer,
  location: locationReducer,
  VisitLocation: VisitLocationReducer,
  User: userReducer,
  userBulkUpload: userBulkUploadReducer,
  leaveType: leaveTypeReducer,
  designation: designationReducer,
  office: officeReducer,
  districtsData: districtsReducer,
  municipalitiesData: municipalitiesReducer,
  admin: adminReducer,
  parkGeofence: parkGeofenceReducer,
  taskAdmin: taskAdminReducer,
  webAdmin: WebAdminReducer,
  blog: blogReducer,
  job: jobReducer,
  shift: shiftReducer,
  attendanceReport: attendanceReportReducer,
});

export default rootReducer;
